/**
 * Locale pt-BR do PrimeVue.
 *
 * Porta do `locale-primefaces-pt_BR.js` do template legado
 * (sisgs-core-template-jsf-pf-ultima/src/main/webapp/resources/scripts/), que no JSF era
 * carregado como script e casava com o <default-locale>pt_BR</default-locale> do faces-config.
 * Os nomes de dias e meses são os mesmos do legado, para as telas ficarem idênticas.
 *
 * No PrimeVue a i18n é global: passar este objeto em app.use(PrimeVue, { locale }) já traduz
 * DatePicker, filtros de DataTable, ConfirmDialog, FileUpload e afins em toda a aplicação.
 */
export const localePtBr = {
  // Calendário / DatePicker
  dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
  dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  monthNames: [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ],
  monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
  today: 'Hoje',
  weekHeader: 'Sem',
  firstDayOfWeek: 0,
  showMonthAfterYear: false,
  dateFormat: 'dd/mm/yy',
  chooseYear: 'Escolha o ano',
  chooseMonth: 'Escolha o mês',
  chooseDate: 'Escolha a data',
  prevDecade: 'Década anterior',
  nextDecade: 'Próxima década',
  prevYear: 'Ano anterior',
  nextYear: 'Próximo ano',
  prevMonth: 'Mês anterior',
  nextMonth: 'Próximo mês',
  prevHour: 'Hora anterior',
  nextHour: 'Próxima hora',
  prevMinute: 'Minuto anterior',
  nextMinute: 'Próximo minuto',
  prevSecond: 'Segundo anterior',
  nextSecond: 'Próximo segundo',
  am: 'am',
  pm: 'pm',

  // Ações comuns (ConfirmDialog, FileUpload, filtros)
  clear: 'Limpar',
  apply: 'Aplicar',
  accept: 'Sim',
  reject: 'Não',
  choose: 'Escolher',
  upload: 'Enviar',
  cancel: 'Cancelar',
  completed: 'Concluído',
  pending: 'Pendente',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],

  // Filtros de DataTable
  startsWith: 'Começa com',
  contains: 'Contém',
  notContains: 'Não contém',
  endsWith: 'Termina com',
  equals: 'Igual',
  notEquals: 'Diferente',
  noFilter: 'Sem filtro',
  lt: 'Menor que',
  lte: 'Menor ou igual a',
  gt: 'Maior que',
  gte: 'Maior ou igual a',
  dateIs: 'Data é',
  dateIsNot: 'Data não é',
  dateBefore: 'Data antes de',
  dateAfter: 'Data depois de',
  matchAll: 'Corresponder a todos',
  matchAny: 'Corresponder a qualquer',
  addRule: 'Adicionar regra',
  removeRule: 'Remover regra',

  // Mensagens
  emptyMessage: 'Nenhum resultado encontrado',
  emptyFilterMessage: 'Nenhum resultado encontrado',
  emptySearchMessage: 'Nenhum resultado encontrado',
  emptySelectionMessage: 'Nenhum item selecionado',
  searchMessage: '{0} resultados disponíveis',
  selectionMessage: '{0} itens selecionados',
  fileChosenMessage: '{0} arquivos',
  noFileChosenMessage: 'Nenhum arquivo escolhido',

  // Força da senha (Password)
  passwordPrompt: 'Digite uma senha',
  weak: 'Fraca',
  medium: 'Média',
  strong: 'Forte',

  aria: {
    trueLabel: 'Verdadeiro',
    falseLabel: 'Falso',
    nullLabel: 'Não selecionado',
    star: '1 estrela',
    stars: '{star} estrelas',
    selectAll: 'Todos os itens selecionados',
    unselectAll: 'Nenhum item selecionado',
    close: 'Fechar',
    previous: 'Anterior',
    next: 'Próximo',
    navigation: 'Navegação',
    scrollTop: 'Rolar para o topo',
    moveTop: 'Mover para o topo',
    moveUp: 'Mover para cima',
    moveDown: 'Mover para baixo',
    moveBottom: 'Mover para o final',
    moveToTarget: 'Mover para o destino',
    moveToSource: 'Mover para a origem',
    moveAllToTarget: 'Mover todos para o destino',
    moveAllToSource: 'Mover todos para a origem',
    pageLabel: 'Página {page}',
    firstPageLabel: 'Primeira página',
    lastPageLabel: 'Última página',
    nextPageLabel: 'Próxima página',
    prevPageLabel: 'Página anterior',
    rowsPerPageLabel: 'Linhas por página',
    jumpToPageDropdownLabel: 'Ir para a página',
    jumpToPageInputLabel: 'Ir para a página',
    selectRow: 'Linha selecionada',
    unselectRow: 'Linha não selecionada',
    expandRow: 'Linha expandida',
    collapseRow: 'Linha recolhida',
    showFilterMenu: 'Mostrar menu de filtro',
    hideFilterMenu: 'Ocultar menu de filtro',
    filterOperator: 'Operador de filtro',
    filterConstraint: 'Restrição de filtro',
    editRow: 'Editar linha',
    saveEdit: 'Salvar edição',
    cancelEdit: 'Cancelar edição',
    listView: 'Visualização em lista',
    gridView: 'Visualização em grade',
    slide: 'Slide',
    slideNumber: '{slideNumber}',
    zoomImage: 'Ampliar imagem',
    zoomIn: 'Aproximar',
    zoomOut: 'Afastar',
    rotateRight: 'Girar para a direita',
    rotateLeft: 'Girar para a esquerda'
  }
};
